angular.module('autoremind.reseller') // no [] allowed since module has already been created
    .controller('autoremind.dashboard.ScreenController', ['$scope', function ($scope) {
    }]);
//# sourceMappingURL=reseller.dashboard.controllers.js.map